<template>
  <div>
    <div class="ovf-hd p-t-10 p-b-50">
      <div class="ovf-hd">
        <slot name="myFlow"></slot>
        <!-- <div class="fl w-300">
          <el-input v-model="keywords" placeholder="输入主题/申请人/编号 搜索"></el-input>
        </div>
        <div class="fl m-l-10">
          <daterange-filter v-model="timeRange"></daterange-filter>
        </div> -->
        <!-- <div class="fl w-150 m-l-20">
          <el-select
            v-model="selectedPeople"
            multiple
            filterable
            remote
            placeholder="请输入关键词"
            :remote-method="remoteMethod"
            :loading="searchLoading">
            <el-option
              v-for="item in people"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div> -->
        <!-- <div class="fl m-l-20">
          <el-button>添加</el-button>
        </div>
        <div class="fl m-l-20">
          <el-button>清除</el-button>
        </div> -->
        <!-- <div class="fl m-l-20">
          <el-button type="primary" @click="search">搜索</el-button>
        </div> -->
      </div>
      <div v-loading="loading">
        <el-table
            :data="flows"
            style="width: 100%"
            @selection-change="selectItem">
          <el-table-column
              type="selection"
              width="50">
          </el-table-column>
          <!-- <el-table-column
          label=""
          width="80">
            <template scope="scope">
              <img class="w-60 h-60" :src="scope.row.face">
            </template>
          </el-table-column> -->
          <el-table-column
              label="编号"
              prop="num"
              width="150">
          </el-table-column>
          <el-table-column
              label="主题"
              header-align="center">
            <template scope="scope">
              <div class="tx-c text-overflow" v-if='caseId === 1'>
                <router-link :to="{ name: 'myFlowDetail', params: { id: scope.row.id }, query: { type_id: scope.row.type_id, type: caseId, node_id: scope.row.case_node_id }}" class="c-icon-blue pointer" :title="scope.row.name">
                  {{ scope.row.name }}
                </router-link>
              </div>
              <div class="tx-c text-overflow" v-if='caseId === 2'>
                <router-link :to="{ name: 'followDetail', params: { id: scope.row.id }, query: { type_id: scope.row.type_id, type: caseId, node_id: scope.row.case_node_id }}" class="c-icon-blue pointer" :title="scope.row.name">
                  {{ scope.row.name }}
                </router-link>
              </div>
              <div class="tx-c text-overflow" v-if='caseId === 3'>
                <router-link :to="{ name: 'dataDetail', params: { id: scope.row.id }, query: { type_id: scope.row.type_id, type: caseId, node_id: scope.row.case_node_id }}" class="c-icon-blue pointer" :title="scope.row.name">
                  {{ scope.row.name }}
                </router-link>
              </div>
              <div class="tx-c text-overflow" v-if='caseId === 4'>
                <router-link :to="{ name: 'myStartDetail', params: { id: scope.row.id }, query: { type_id: scope.row.type_id, type: caseId, node_id: scope.row.case_node_id }}" class="c-icon-blue pointer" :title="scope.row.name">
                  {{ scope.row.name }}
                </router-link>
              </div>
            </template>
          </el-table-column>
          <el-table-column
              label="申请人"
              width="200">
            <template scope="scope">
              <div>
                {{ scope.row.apply_name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="create_time"
              label="流程发起时间"
              header-align="center"
              sortable
              width="150">
            <template scope="scope">
              <div class="tx-c">
                {{ scope.row.create_time | toTime}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="deal_time"
              label="最后处理时间"
              header-align="center"
              sortable
              width="150">
            <template scope="scope">
              <div class="tx-c">
                {{ scope.row.deal_time | toTime}}
              </div>
            </template>
          </el-table-column>
          <el-table-column
              prop="case_status"
              label="状态"
              v-if='!(caseId === 1)'>
          </el-table-column>
        </el-table>
      </div>
      <div style="position:relative;height:40px" v-if="caseId == 3">
        <el-button type="default" @click="exportData" style="position:absolute;right:0;top:10px">导出</el-button>
      </div>
      <div class="pos-rel p-t-20">
        <btnGroup :selectedData="multipleSelection" type="bpm/flowCases/deletes" need="del" @setLoading="setLoading" v-if="caseId == 3"></btnGroup>
        <div class="block pages">
          <el-pagination
              @current-change="handleCurrentChange"
              @size-change="handleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
              :page-sizes="[10, 15, 20]"
              :page-size="limit"
              :current-page="currentPage"
              :total="dataCount">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import http from '../../../assets/js/http'
  import daterangeFilter from '../../Common/business/filter/daterangeFilter'
  import btnGroup from '../../Common/normal/btn-group'

  export default {
    name: 'followList',
    props: {
      caseId: {           // caseId：我的待办、经办跟踪、数据管理
        type: Number,
        default() {
          return 1
        }
      },
      // typeId: {           // typeId：类别ID
      //   type: Number,
      //   default() {
      //     return 0
      //   }
      // },
      path: {             // path：路径
        type: String
      }
    },
    data() {
      return {
        limit: 10,
        currentPage: 1,
        dataCount: null,
        loading: false,
        searchLoading: false,
        flows: [],
        people: [],
        selectedPeople: [],
        typeId: 0,
        // timeRange: [],
        startTime: '',
        endTime: '',
        multipleSelection: []
      }
    },
    methods: {
      selectItem(val) {
        this.multipleSelection = val
      },
      exportData() {
        this.loading = true
        const query = {
          type_id: this.caseId,
          keywords: this.keywords,
          startTime: this.startTime,
          endTime: this.endTime
        }
        let newWin = window.open('', '_blank')
        this.apiPost('bpm/flowCases/export', query).then((res) => {
          this.loading = false
          if (res.code == 200) {
            newWin.location = HOST + res.data
          } else {
            _g.dealError(this, res)
          }
          setTimeout(() => {
            newWin.close()
          }, 500)
        })
      },
      remoteMethod() {
      },
      handleCurrentChange(page) {
        router.push({ path: this.path, query: { page: page, limit: this.limit, keywords: this.keywords, startTime: this.startTime, endTime: this.endTime }})
      },
      handleSizeChange(limit) {
        router.push({ path: this.path, query: { page: 1, limit: limit, keywords: this.keywords, startTime: this.startTime, endTime: this.endTime }})
      },
      // search() {
      //   router.push({ path: this.path, query: { page: 1, limit: this.limit, keywords: this.keywords, startTime: this.startTime, endTime: this.endTime }})
      // },
      getFlows() {
        this.loading = true
        const query = {
          params: {
            caseType: this.caseId, // 一级类别
            limit: this.limit,
            page: this.currentPage,
            keywords: this.keywords,
            startTime: this.startTime,
            endTime: this.endTime
          }
        }
        this.apiGet(`bpm/types/${this.typeId}/cases`, query).then((res) => {
          this.loading = false
          if (res.code == 200) {
            this.flows = res.data.list
            this.dataCount = res.data.dataCount
          } else {
            _g.dealError(this, res)
          }
        })
      },
      resetFilter(route) {
        this.typeId = parseInt(route.query.typeId) ? parseInt(route.query.typeId) : 0 // 二级类别
        this.currentPage = parseInt(route.query.page) ? parseInt(route.query.page) : 1
        this.keywords = route.query.keywords
        this.limit = parseInt(route.query.limit) ? parseInt(route.query.limit) : 10
        this.startTime = route.query.startTime
        this.endTime = route.query.endTime
      },
      setLoading(value) {
        this.loading = value
      }
    },
    created() {
      this.resetFilter(this.$route)
      this.getFlows()
    },
    watch: {
      'timeRange'() {
        this.startTime = this.timeRange[0]
        this.endTime = this.timeRange[1]
      },
      // 'typeId'() {
      //   this.currentPage = 1
      //   this.limit = 15
      //   this.keywords = ''
      //   this.timeRange = []
      //   this.startTime = ''
      //   this.endTime = ''
      //   this.getFlows()
      // },
      '$route' (to, from) {
        this.resetFilter(to)
        this.getFlows()
      }
    },
    components: {
      daterangeFilter,
      btnGroup
    },
    mixins: [http]
  }
</script>
<style>
  .el-checkbox__inner {
    margin-bottom: 1px !important;
  }
</style>


// WEBPACK FOOTER //
// flowList.vue?507fc28c